import { kbbBrand } from '../constants';
import { updateOwnerData as updateOwnersData } from '../utilities';

export default function processOwnerResultsCtx() {
    return async (ctx) => {
        const updatedOwnersData = await updateOwnersData(ctx.data.owners, ctx.data.brand === kbbBrand, ctx.query);
        Object.assign(ctx.data, updatedOwnersData);
    };
}
